import { TrlPillExecuted } from './TrlPillExecuted';

export { TrlPillExecuted } from './TrlPillExecuted';
export default TrlPillExecuted;
